import $ from 'jquery';

const GetChannelArticles = (breakPoint) => {
  const url = window.matchMedia(`(max-width: ${breakPoint}px)`).matches ? 'https://bangumi.gu3.co.jp/wp-json/wp/v2/posts?per_page=4&_embed' : 'https://bangumi.gu3.co.jp/wp-json/wp/v2/posts?per_page=2&_embed'
  $.ajax({
    url: url,
    type: 'GET',
    dataType: 'json',
  })
    .done(function (data) {
      $.each(data, function (index, val) {
        var title = val.title.rendered;
        var link = val.link;
        var thum = "";
        if (val['_embedded']['wp:featuredmedia']) {
          thum = val['_embedded']['wp:featuredmedia'][0]['media_details']['sizes']['icatch375']['source_url']
        }
        var textNode = `<li class="channel__item"><a class="channel__link" href="${link}" target="_blank">`;
        textNode += '<p>' + title + '</p>';
        textNode += '<figure class="channel__figure"><img class="u-objFit" src="' + thum + '" alt="' + title + '"></figure>';
        textNode += '</a></li>';
        $('.channel__list').append(textNode);
      });
    })
    .fail(function () {
      // 通信失敗時の処理を記述
      console.error('記事取得に失敗しました。')
    });
}

export default GetChannelArticles;


// WEBPACK FOOTER //
// ./src/recruit/js/getChannelArticles.js